import { SIZE, SPOT_LOADER_SIZE, BAR_LOADER_WIDTH, TWO_PI, SPINNER_CONTAINER_SIZE, SPINNER_RADIUS, SPINNER_LOGO_SIZE, SPINNER_WIDTH, } from '../constants';
export const getFontStyle = ({ size, theme }) => {
    const { subTitleSmall, subTitleMedium, subTitleLarge } = theme.typography;
    switch (size) {
        case SIZE.small: {
            return subTitleSmall;
        }
        case SIZE.medium: {
            return subTitleSmall;
        }
        case SIZE.large: {
            return subTitleMedium;
        }
        case SIZE.xLarge: {
            return subTitleLarge;
        }
        default: {
            return {};
        }
    }
};
// Helpers for Spinner Loader
export const getSpinnerSizeStyle = ({ size }) => {
    const { small, medium, large, xLarge, } = SPINNER_CONTAINER_SIZE;
    let dimensions = large;
    switch (size) {
        case SIZE.small:
            dimensions = small;
            break;
        case SIZE.medium:
            dimensions = medium;
            break;
        case SIZE.large:
            dimensions = large;
            break;
        case SIZE.xLarge:
            dimensions = xLarge;
            break;
        default:
            break;
    }
    return { height: `${dimensions}px`, width: `${dimensions}px` };
};
export const getSpinnerDimensions = ({ size }) => {
    const { small: smallRadius, medium: mediumRadius, large: largeRadius, xLarge: xLargeRadius, } = SPINNER_RADIUS;
    const { small: smallWidth, medium: mediumWidth, large: largeWidth, xLarge: xLargeWidth, } = SPINNER_WIDTH;
    let radius = largeRadius;
    let width = largeWidth;
    switch (size) {
        case SIZE.small:
            radius = smallRadius;
            width = smallWidth;
            break;
        case SIZE.medium:
            radius = mediumRadius;
            width = mediumWidth;
            break;
        case SIZE.large:
            radius = largeRadius;
            width = largeWidth;
            break;
        case SIZE.xLarge:
            radius = xLargeRadius;
            width = xLargeWidth;
            break;
        default:
            break;
    }
    return {
        r: radius,
        strokeWidth: `${width}px`,
    };
};
export const getSpinnerLogoSize = ({ size }) => {
    const { small, medium, large, xLarge, } = SPINNER_LOGO_SIZE;
    let width = large;
    switch (size) {
        case SIZE.small:
            width = small;
            break;
        case SIZE.medium:
            width = medium;
            break;
        case SIZE.large:
            width = large;
            break;
        case SIZE.xLarge:
            width = xLarge;
            break;
        default:
            break;
    }
    return { width: `${width}px` };
};
// Circumference is 2 pi r
export const getDasharray = ({ size }) => (getSpinnerDimensions({ size }).r * TWO_PI);
export const getDashoffset = ({ value, size }) => {
    const circumference = getSpinnerDimensions({ size }).r * TWO_PI;
    const filledPart = circumference - ((value / 100) * circumference);
    return `${filledPart}px`;
};
// Helpers for Bar Loader
export const getBarLoaderWidth = ({ fullScreen, width }) => {
    if (fullScreen) {
        return 'inherit';
    }
    return width || BAR_LOADER_WIDTH;
};
// Helpers for spot loader
export const getSpotSize = ({ size }) => {
    let dimensions = SPOT_LOADER_SIZE.large;
    let marginRight = 3;
    switch (size) {
        case SIZE.small:
            dimensions = SPOT_LOADER_SIZE.small;
            marginRight = dimensions;
            break;
        case SIZE.medium:
            dimensions = SPOT_LOADER_SIZE.medium;
            marginRight = dimensions;
            break;
        case SIZE.large:
            dimensions = SPOT_LOADER_SIZE.large;
            marginRight = dimensions;
            break;
        case SIZE.xLarge:
            dimensions = SPOT_LOADER_SIZE.xLarge;
            marginRight = 6;
            break;
        default:
            break;
    }
    return {
        borderWidth: `${dimensions}px`,
        marginRight: `${marginRight}px`,
    };
};
export const getSpinnerBackground = ({ theme, withBackground, size }) => {
    if (!withBackground) {
        return null;
    }
    const { colors, borders, spacing, elevations, } = theme;
    const { spacing60, spacing80 } = spacing;
    return {
        background: colors.surface,
        borderRadius: borders.radius35,
        padding: (size === SIZE.xLarge) ? spacing80 : spacing60,
        boxShadow: elevations.shadow100,
    };
};
